import { Pagination as PolarisPagination } from "@shopify/polaris";

const Pagination = ({ pageCount, currentPage, handlePageChange }: any) => {
  return (
    <nav
      className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
      aria-label="Table navigation"
    >
      <span className="text-sm font-normal text-gray-500">
        Showing{" "}
        <span className="font-semibold text-gray-900">{currentPage}</span> page
        of <span className="font-semibold text-gray-900">{pageCount}</span>
      </span>
      <PolarisPagination
        hasPrevious={currentPage > 1}
        onPrevious={() => handlePageChange(currentPage - 1)}
        hasNext={pageCount > currentPage}
        onNext={() => {
          if (pageCount > currentPage) {
            handlePageChange(currentPage + 1);
          }
        }}
      />
    </nav>
  );
};

export default Pagination;
